import { PlatformRole } from "@hex/common";
import React from "react";

import { HexMenuItem } from "../../hex-components";
import { useOnClickProps } from "../../hooks/useOnClickProps";
import { CurrentUser } from "../../redux/slices/currentUserSlice.js";
import { Routes } from "../../route/routes";
import { TestSelectors } from "../../util/testSelectors";
import { GlobeIcon } from "../icons/CustomIcons";

interface AdminMenuItemsProps {
  currentUser: CurrentUser;
}

export const AdminMenuItems: React.FunctionComponent<AdminMenuItemsProps> = ({
  currentUser,
}) => {
  const isPlatformAdmin =
    currentUser.platformRole === PlatformRole.ADMIN ||
    currentUser.platformRole === PlatformRole.ADMIN_READ_ONLY;

  const platformAdminProps = useOnClickProps({
    to: Routes.ADMIN_PLATFORM.getUrl({}),
  });

  return (
    <>
      {isPlatformAdmin && (
        <HexMenuItem
          data-test={TestSelectors.PLATFORM_ADMINISTRATION}
          icon={<GlobeIcon />}
          text="Platform Administration"
          {...platformAdminProps}
        />
      )}
    </>
  );
};
